import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BfAuthService } from '@brafton/skynet-angular-security-service';

@Component({
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LandingPageComponent implements OnInit {
  constructor(private authService: BfAuthService) {}

  ngOnInit() {
    this.authService.login();
  }
}
